var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-entrega',{attrs:{"entrega":_vm.entrega,"entregasServicos":_vm.obterEntregasServicos()},on:{"obterEntregaAtualizada":function($event){return _vm.obterAtualizacao()}}},[_c('template',{slot:"contratacaoFooter"},[_c('app-btn-voltar')],1),_c('template',{slot:"entregaFooter"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }